import ResourcesAsTable from './ResourcesAsTable'
export default ResourcesAsTable
